import React from 'react';
import { IImage } from 'tbk-components/src/components/Image';
import imgWaterloo from '../../assets/img/goodwill-waterloo.jpg';

export interface ISingleLocationHeader {
	title: string;
	openingText: string;
	heroImage: IImage;
}

export interface ISingleLocationHeaderProps {
	header: ISingleLocationHeader;
}

const SingleLocationHeader: React.FC<ISingleLocationHeaderProps> = ({
	header: { title, openingText, heroImage },
}) => (
	<div className="location-single__header">
		<div className="header-info">
			<div className="header-info-text">
				{title && <h1>{title}</h1>}
				{openingText && (
					<p dangerouslySetInnerHTML={{ __html: openingText }} />
				)}
			</div>
		</div>
		<div className="header-image">
			{heroImage ? (
				<img src={heroImage.src} alt={heroImage.alt} />
			) : (
				<img src={imgWaterloo} alt="Goodwill" />
			)}
		</div>
	</div>
);

export default SingleLocationHeader;
